import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';

import Sticky from 'rise-ui/components/sticky.gjs';
import TimeSeriesStepsStickySmall from 'rise-ui/components/time-series/steps-sticky-small.gjs';
import TimeSeriesStepsStickyLarge from 'rise-ui/components/time-series/steps-sticky-large.gjs';
import TimeSeriesSteps from 'rise-ui/components/time-series/steps.gjs';
import string from 'rise-ui/helpers/string.js';
import sticky from 'rise-ui/modifiers/sticky.js';

export default RouteTemplate(class TimeSeriesTemplate extends Component {
  <template>
    <div class="id-time-series c-section">
      <Sticky @name="title">
        <h3 class="c-sticky-title">{{string "time-series-route"}}</h3>
      </Sticky>
      <h3 class="c-page-title id-time-series__page-title qa-page-title"
        {{sticky activate="title"}}
      >
        {{string "time-series-route"}}
      </h3>
      <TimeSeriesStepsStickySmall />
      <TimeSeriesStepsStickyLarge />
      <TimeSeriesSteps />
      {{outlet}}
    </div>
  </template>
});
